import { Menu, MenuDropdownProps } from '@mantine/core';
import styled from 'styled-components';

export const BreakpointOverrideCellInner = styled.div<{ alignEnd?: boolean; padding?: string }>`
	display: flex;
	align-items: center;
	gap: 0.5rem;
	text-overflow: ellipsis;
	overflow-y: hidden;
	overflow: hidden;
	width: 100%;
	display: flex;
	justify-content: space-between;
	padding: 1rem;
`;

export const BreakpointOverrideIndicator = styled.div`
	background-color: ${({ theme }) => theme.v3.colors.orange[0]};
	border: 1px solid ${({ theme }) => theme.v3.colors.orange[2]};
	border-radius: 0.25rem;
	padding: 0 0.125rem;
`;

export const SecurityRowMenuItem = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
	min-width: 14.5rem;
	padding: 0.5rem;
`;

export const SecurityRowMenuDropdown = styled(Menu.Dropdown)<MenuDropdownProps>`
	border: none;
	${({ theme }) => theme.shadow.z1}
`;
